import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { ErrorObservable } from '../../services.module/message.observable';
import { ErrorModel, ErrorSeverity } from '../../model.module/modals.model';
import { AppConstants } from '../../app-constants.service';
import { PartnerService } from '../../providers.module/partner.service';
import { Buergschein, PartnerProfilData } from '../../../generated/api/kreditportalBackendAPI.schemas';

@Component({
    selector: 'print-enthaftungserklaerung',
    templateUrl: './enthaftungserklaerung.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrintEnthaftungserklaerung {

    @Input()
    model: Buergschein = null;

    @Input()
    shown = false;

    partnerModel: PartnerProfilData;

    constructor(
        private readonly appConstants: AppConstants,
        private readonly errorHandler: ErrorObservable,
        private readonly partnerService: PartnerService
    ) {
        this.partnerService.getPartner().subscribe({
            next: partnerResponse => {
                this.partnerModel = partnerResponse;
            },
            error: err => {
                this.errorHandler.notify(new ErrorModel(
                    ErrorSeverity.FATAL,
                    this.appConstants.messages.fehlerAufgetreten,
                    [],
                    undefined
                ));

                this.shown = false;
            }
        });
    }

    notifyOpen(open: boolean): void {
        this.shown = open;
    }

}

